<template>
  <div class="players">
    <bird-player v-for="player in players" :player="player"></bird-player>
  </div>
</template>
<script>
  import Player from "./Player.vue"
  import { mapGetters } from "vuex"

  export default {
    computed: {
      ...mapGetters(["players"])
    },
    components: {
      birdPlayer: Player
    }
  }
</script>
<style scoped>
  .players {
    display: flex;
    flex-direction: column;
    width: 25%;
    margin: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Players.vue